import { ProductionTypes } from '@shared/utils/app-config';

export const environment = {
  production: true,
  productionType: ProductionTypes.isIndustrialCam,
  baseApiUrl: 'https://api.industrial.video/',
  baseNewApiUrl: '',
  translations: {
    en: '/assets/translations/industrial-cam/en.json',
  },
  applicationInsights: {
    instrumentationKey: '81ec4a39-4936-4a32-826b-a9859f796c13',
  },
  googleMaps: {
    apiKey: 'industrialCam_GoogleMapsApiKey',
  },
  statics: {
    logo: '',
    background: '',
    favicon: './assets/images/iCamLogo.svg',
    blueLogo: './assets/images/iCamLogo.svg',
    downloadLink: 'https://download.industrial.video/Installer/Setup.exe',
    userDefaultUploadImage: './assets/images/user140.svg',
    noPreviewAvailable: './assets/images/no-preview-available.png',
    unlabeledEvidence: './assets/images/unlabeled_evidence.svg',
    evidenceLabeling: './assets/images/evidence_labeling.svg',
    zoomIn: './assets/images/zoomIn.png',
    zoomOut: './assets/images/zoomOut.png',
    rotatecw: './assets/images/rotatecw.png',
    rotateaw: './assets/images/rotateaw.png',
    closeGalleryIcon: './assets/images/close-gallery-icon.png',
  },
  b2cConfig: {
    clientId: '107fdba9-f6e1-4b38-80e4-202bb277ab3e',
    authority: 'https://industrialcam.b2clogin.com/industrialcam.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
    redirectUri: 'https://app.industrial.video',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
    b2cApiScope: 'https://industrialcam.onmicrosoft.com/d184a609-aa2f-431e-91a9-168c125e1b5c/IndustialCam.FullAccess',
    b2cNewApiScope: 'https://industrialcam.onmicrosoft.com/d184a609-aa2f-431e-91a9-168c125e1b5c/IndustrialCam.FullAccess',
    b2cScopes: ['openid', 'offline_access', 'profile', 'email'],
    knownAuthorities: 'industrialcam.b2clogin.com',
  },
  tracking: {
    analyticsId: null,
    clarityId: null,
  },
};
